export enum CHART_TYPE_NAMES {
    STACKED_BAR_FACTOR_SCORES = 'stacked_bar_chart_factor_scores',
    SCATTER_TWO_FACTOR_COMPARISON = 'two_factor_comparison_scatter_chart',
    BAR_FACTOR_IMPORTANCE = 'factor_importance_bar_chart'
}

export const CHART_TYPES = [
    {
        display: 'Factor Scores Stacked Bar Chart',
        value: CHART_TYPE_NAMES.STACKED_BAR_FACTOR_SCORES
    }, {
        display: 'Two Factor Comparison Scatter Chart',
        value: CHART_TYPE_NAMES.SCATTER_TWO_FACTOR_COMPARISON
    }, {
        display: 'Factor Importance Bar Chart',
        value: CHART_TYPE_NAMES.BAR_FACTOR_IMPORTANCE
    }
]